<template>
  <div class>
    <div class="d-flex justify-content-center">
      <div class="col-12" v-if="showLogin">
        <!--   Login form for branded stores     -->
        <form
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
          @submit.prevent="submit"
          v-if="isBranded()"
        >
          <div
            v-if="redirectedFromCheckout"
            class="w-75 justify-content-center"
          >
            <button
              type="button"
              @click="skipAuthAndCheckout()"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
            >
              {{ $t("message.continueAsGuest") }}
            </button>
            <!--       horizontal divider -->
            <div class="w-100 d-flex align-content-center mt-2">
              <div class="divider w-50 mt-3"></div>

              <span class="px-2 mt-1">{{ $t("message.or") }}</span>

              <div class="divider w-50 mt-3"></div>
            </div>
          </div>

          <h3
            class="w-75 mt-3 mb-4 d-flex"
            :class="
              fullScreen ? 'justify-content-start' : 'justify-content-center'
            "
            v-if="isLogin"
          >
            {{ $t("message.signInToYourAccount") }}
          </h3>
          <h3 class="w-75 mt-3 mb-5 d-flex justify-content-center" v-else>
            {{ $t("message.forgotPassword") }}
          </h3>
          <div class="form-group w-75">
            <label for="exampleInputEmail1">{{ $t("message.email") }}</label>
            <input
              v-validate="'required|email'"
              id="exampleInputEmail1"
              v-model="email"
              type="text"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
              :class="fullScreen && 'bg-gray'"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("email") | inputNameLocale("email") }}
            </div>
          </div>
          <div class="form-group w-75" v-if="isLogin">
            <label for="exampleInputPassword1">{{
              $t("message.password")
            }}</label>
            <input
              v-validate="'required'"
              id="exampleInputPassword1"
              v-model="password"
              type="password"
              name="password"
              class="form-control"
              :class="fullScreen && 'bg-gray'"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("password") | inputNameLocale("password") }}
            </div>
          </div>
          <div v-if="isLogin" :class="fullScreen && 'mt-4'" class="w-75 mt-1">
            <a
              :style="desktopStyles.LinkColorTxt"
              href="#"
              style="float: right; margin-top: -0.875rem"
              @click="switchView(false)"
              >{{ $t("message.forgotPassword") }}?</a
            >
          </div>
          <div class="w-75 mt-1" v-else>
            <a
              :class="fullScreen && 'mt-2'"
              :style="desktopStyles.LinkColorTxt"
              href="#"
              style="float: right; margin-top: -0.875rem"
              @click="switchView(true)"
              >{{ $t("message.login") }}</a
            >
          </div>
          <div
            class="w-60 mt-4 justify-content-center"
            v-if="hqDoc && hqDoc.TermsAndConditions"
          >
            <a href="#" @click.prevent="$emit('toggleTC')">
              <p
                v-html="$t('message.termsOfUsePrivacyStatement')"
                style="
                  font-size: 0.6875rem;
                  line-height: 1.4;
                  text-align: center;
                "
              ></p>
            </a>
          </div>
          <div class="w-75 d-flex justify-content-between">
            <button
              v-if="isLogin"
              :disabled="loading"
              type="submit"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              :style="desktopStyles.btn"
            >
              {{ $t("message.signIn") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
            <button
              v-else
              :disabled="loading"
              type="submit"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              :style="desktopStyles.btn"
            >
              {{ $t("message.sendLink") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div
            class="w-75 mt-5 mb-5 d-flex justify-content-center font-weight-bold"
          >
            {{ $t("message.haventGotAnAccount") }}? &nbsp;
            <a
              :style="desktopStyles.LinkColorTxt"
              href="#"
              @click="goToRegister(2)"
              >{{ $t("message.register") }}</a
            >
          </div>
          <div
            v-if="FacebookLogin || GoogleLogin"
            class="w-75 mb-3 d-flex justify-content-center"
          >
            <strong>{{ $t("message.orSignInWith") }}</strong>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>

          <div class="container">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login @close-overlay="$emit('close-overlay')" />
            </div>
          </div>
          <div v-show="msg" class="w-75 mt-4">
            <div class="alert alert-success" role="alert">
              <strong>{{ msg }}</strong>
            </div>
          </div>
        </form>

        <!--    Login form for non branded stores    -->
        <div v-else>
          <!--     step two form to enter OTP     -->
          <form
            class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
            v-if="step === 2"
          >
            <h4 class="w-75 mt-3 mb-5 d-flex justify-content-center">
              {{ $t("message.enterCodeSentTo") }}
              {{ this.countryCode + this.mobile }}
            </h4>

            <div class="form-group w-full">
              <OtpInput
                ref="otpInput"
                input-classes="otp-input"
                autocomplete="one-time-code"
                separator="-"
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-complete="verifyNonBrandedOtp"
              />
            </div>

            <div
              class="w-85 mt-4 d-flex align-items-center justify-content-center"
            >
              <span>{{ $t("message.smsResendDescription") }}</span>
              <button
                type="button"
                class="btn btn-link pl-1 resend-btn"
                :disabled="!enableResendBtn || loading"
                :style="desktopStyles.LinkColorTxt"
                @click="resendSms"
              >
                {{ $t("message.smsResendButton") }}
                <span v-show="!enableResendBtn && !loading"
                  >({{ resendWait }})</span
                >
              </button>
            </div>

            <div class="w-75 mt-3">
              <button
                :disabled="loading"
                :style="desktopStyles.btn"
                type="submit"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
              >
                {{ $t("message.confirm") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>

            <div v-show="error" class="w-75 mt-4">
              <div class="alert alert-danger" role="alert">
                <strong>{{ error }}</strong>
              </div>
            </div>
          </form>

          <!--     step one form to enter mobile number     -->
          <form
            class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
            v-else
          >
            <h3
              class="w-75 mt-3 mb-5 d-flex justify-content-center"
              v-if="isLogin"
            >
              {{ $t("message.signInToYourAccount") }}
            </h3>

            <div class="form-group w-75">
              <label for="mobile"
                >{{ $t("message.phoneNumber") }}
                <span class="required-logo">*</span></label
              >
              <div class="row">
                <div class="col-2">
                  <VueCountryCode
                    @onSelect="selectCountryCode"
                    :preferredCountries="['au', 'us', 'gb']"
                  />
                </div>

                <div class="col-10">
                  <input
                    v-validate="{
                      required: true,
                      min: 6,
                    }"
                    id="mobile"
                    v-model="mobile"
                    name="mobile"
                    type="tel"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div
              class="w-60 mt-4 justify-content-center"
              v-if="hqDoc && hqDoc.TermsAndConditions"
            >
              <a href="#" @click.prevent="$emit('toggleTC')">
                <p
                  v-html="$t('message.termsOfUsePrivacyStatement')"
                  style="
                    font-size: 0.6875rem;
                    line-height: 1.4;
                    text-align: center;
                  "
                ></p>
              </a>
            </div>

            <div class="w-75 d-flex justify-content-between">
              <button
                type="button"
                :disabled="loading"
                class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
                :style="desktopStyles.btn"
                @click="sendOtpNonBrandedStoreUser"
              >
                {{ $t("message.signIn") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>

            <div
              class="w-75 mt-5 mb-5 d-flex justify-content-center font-weight-bold"
            >
              {{ $t("message.haventGotAnAccount") }}? &nbsp;
              <a
                href="#"
                :style="desktopStyles.LinkColorTxt"
                @click="goToRegister(2)"
                >{{ $t("message.register") }}</a
              >
            </div>

            <div v-show="error" class="w-75 mt-4">
              <div class="alert alert-danger" role="alert">
                <strong>{{ error }}</strong>
              </div>
            </div>

            <div v-show="msg" class="w-75 mt-4">
              <div class="alert alert-success" role="alert">
                <strong>{{ msg }}</strong>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/login.js";
import register from "../../sharedscripts/user/register";
import AuthProvidersLogin from "./AuthProvidersLogin";
import { mapActions, mapGetters } from "vuex";
import VueCountryCode from "vue-country-code";
import OtpInput from "@bachdgvn/vue-otp-input";

export default {
  components: {
    AuthProvidersLogin,
    VueCountryCode,
    OtpInput,
  },
  props: {
    storeid: {
      type: String,
      default: null,
    },
    forgift: {
      type: Boolean,
      default: false,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    overlayActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLogin: true,
      email: "",
      mobile: "",
      countryCode: "",
      step: 1,
      password: "",
      loading: false,
      error: "",
      msg: "",
      resendWait: 30, //seconds
      smsTimer: null,
    };
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      "viewConfig",
      "currentStoreDoc",
      "hqDoc",
      "redirectedFromCheckout",
    ]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    },
    showLogin() {
      return this.viewConfig.LogIn || this.isBranded();
    },
    enableResendBtn() {
      return this.resendWait === 0;
    },
  },
  watch: {
    overlayActive() {
      this.step = 1;
    },
  },
  mounted() {
    this.setStoreLoaded();
    this.initReCaptcha();
  },
  methods: {
    ...shared.methods,
    ...register.methods,
    ...mapActions(["setOverlayIndex"]),
    selectCountryCode(value) {
      this.countryCode = `+${value.dialCode}`;
    },
    goToRegister(index = 0) {
      if (this.fullScreen) {
        this.$router.push(
          "/store/" + this.$route.params.storename + "/register"
        );
        return;
      }
      this.setOverlayIndex(index);
    },
  },
};
</script>
